import conf from './conf';
import auth from './auth';
import data from './data';
import ctrl from './ctrl';
import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {intlReducer} from 'react-intl-redux';

export default combineReducers({
   conf,
   auth,
   data,
   ctrl,
   routing: routerReducer,
   intl: intlReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js